import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { GetTransferAgentsChildDto } from '@app/dialler/models';
import { DiallerService } from '@app/dialler/services';
import { WorkService } from '@app/work/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, take, withLatestFrom } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { ListTenantSpeedDialsDto } from '../models';
import { SpeedDialsService } from '../services';

@Component({
  selector: 'app-transfer',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Transfer Caller</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.close('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      Free Transfer:
      <div class="input-group mb-3">
        <input
          #transfernumber
          class="form-control"
          placeholder="Transfer Number"
          [value]="this.phonedefault"
        />
        <div class="input-group-append">
          <div class="input-group-text">
            <span
              style="cursor: pointer"
              (click)="
                this.transfer(transfernumber.value);
                activeModal.close('Close click')
              "
            >
              Transfer
            </span>
          </div>
        </div>
      </div>

      <div style="margin-top: 10px;margin-bottom: 10px;">
        3 Way Transfer
        <input type="checkbox" (click)="this.toggle3way()" />
      </div>
      <ul ngbNav #nav="ngbNav" class="nav-tabs">
        <li ngbNavItem>
          <a ngbNavLink>Agents</a>
          <ng-template ngbNavContent>
            <table style="margin-top: 20px;">
              <tbody>
                <tr>
                  <td colspan="2">
                    <input
                      #searchtext
                      (keyup)="this.requery(searchtext.value)"
                      placeholder="Filter..."
                    />
                  </td>
                </tr>
                <ng-container *ngFor="let agent of transferagents$ | async">
                  <tr>
                    <td>
                      <input
                        type="radio"
                        name="radiogroup"
                        value="{{
                          agent.state === 'Available' ? agent.userId : -1
                        }}"
                        (change)="this.selectAgent(agent)"
                        [checked]="this.selectedagent === agent.userId"
                      />
                    </td>
                    <td
                      (click)="this.selectAgent(agent)"
                      style="padding-left: 10px;cursor: pointer;"
                      [style.color]="
                        agent.state === 'Available' ? 'green' : 'orange'
                      "
                    >
                      {{ agent.userName }} - {{ agent.state }}
                    </td>
                  </tr>
                </ng-container>
                <tr>
                  <td colspan="2" style="padding-top: 10px;">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="
                        this.transferToAgent(); activeModal.close('Close click')
                      "
                    >
                      Transfer To Agent
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-template>
        </li>
        <li ngbNavItem>
          <a ngbNavLink>Speed Dials</a>
          <ng-template ngbNavContent>
            <table style="margin-top: 20px;">
              <tbody>
                <tr>
                  <td colspan="2">
                    <input
                      #speeddialsearchtext
                      (keyup)="this.requeryspeeddial(speeddialsearchtext.value)"
                      placeholder="Filter..."
                    />
                  </td>
                </tr>
                <ng-container *ngFor="let speeddial of speeddials$ | async">
                  <tr *ngIf="speeddial.active">
                    <td>
                      <input
                        type="radio"
                        name="radiogroup"
                        value="{{ speeddial.number }}"
                        (change)="this.selectSpeeddial(speeddial)"
                        [checked]="this.selectnumber === speeddial.number"
                      />
                    </td>
                    <td
                      style="padding-left: 10px;cursor: pointer;"
                      (click)="this.selectSpeeddial(speeddial)"
                    >
                      {{ speeddial.name }}
                    </td>
                    <td
                      style="padding-left: 10px;cursor: pointer;"
                      (click)="this.selectSpeeddial(speeddial)"
                    >
                      {{ speeddial.number }}
                    </td>
                  </tr>
                </ng-container>
                <tr>
                  <td colspan="2" style="padding-top: 10px;">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="
                        this.dialSelectedSpeeddial();
                        activeModal.close('Close click')
                      "
                    >
                      Call Speed Dial
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransferComponent {
  private subs = new SubSink();
  private threeway: boolean = false;

  phonedefault: string = '';
  selectedagent: number = 0;
  selectnumber: string = '';
  speeddials$ = this.speedDialsSvc.speeddials$;
  stopRecording: boolean = false;
  transferagents$ = this.diallerSvc.transferAgents$;

  constructor(
    private speedDialsSvc: SpeedDialsService,
    public activeModal: NgbActiveModal,
    private diallerSvc: DiallerService,
    private workSvc: WorkService
  ) {
    this.workSvc.defaultTenantId$.pipe(take(1)).subscribe((tid) => {
      if (tid === 90) this.phonedefault = '0892616';
    });
  }

  dialSelectedSpeeddial() {
    if (this.selectnumber != '') {
      this.diallerSvc.xferStopRecording = this.stopRecording;

      if (this.threeway) {
        this.diallerSvc.agent3Way(this.selectnumber, '', 30000);
      } else {
        if (this.diallerSvc.xferStopRecording) this.diallerSvc.stopRecording();
        this.diallerSvc.transferToAgent(this.selectnumber, '', '');
      }
    }
  }

  requery(searchvalue: string) {
    this.diallerSvc.getTransferAgents(searchvalue);
    this.transferagents$ = this.diallerSvc.transferAgents$;
  }

  requeryspeeddial(searchvalue: string) {
    this.speedDialsSvc.requerySpeedDials(searchvalue);
    this.speeddials$ = this.speedDialsSvc.speeddials$;
  }

  selectAgent(agent: GetTransferAgentsChildDto) {
    this.selectedagent = agent.userId;
  }

  selectSpeeddial(speeddial: ListTenantSpeedDialsDto) {
    this.selectnumber = speeddial.number;
    this.stopRecording = speeddial.xferStopRecording;
  }

  toggle3way() {
    if (this.threeway == false) {
      this.threeway = true;
    } else {
      this.threeway = false;
    }
  }

  transfer(xfernumber: string) {
    if (xfernumber != '') {
      this.diallerSvc.xferStopRecording = true;

      if (this.threeway) {
        this.diallerSvc.agent3Way(xfernumber, '', 30000);
      } else {
        this.diallerSvc.stopRecording();
        this.diallerSvc.transferToAgent(xfernumber, '', '0');
      }
    }
  }

  transferToAgent() {
    if (this.selectedagent > -1) {
      this.diallerSvc.xferStopRecording = true;

      this.workSvc.master$
        .pipe(take(1), withLatestFrom(this.workSvc.campaignId$))
        .subscribe(([master, campaignId]) => {
          let leadid: string = '';
          if (
            !this.diallerSvc.isIB() &&
            master !== undefined &&
            master.recordId !== undefined
          ) {
            leadid = master.recordId?.toString();
          } else {
            leadid = campaignId!.toString();
          }

          if (this.threeway) {
            this.diallerSvc.agent3Way(
              this.selectedagent.toString(),
              leadid,
              30000
            );
          } else {
            this.diallerSvc.stopRecording();
            this.diallerSvc.transferToAgent(
              this.selectedagent.toString(),
              leadid,
              '0'
            );
          }
        });
    }
  }
}
